import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the slackVerify state domain
 */

const selectVerifySlackDomain = state => state.slackVerify || initialState;

/**
 * Other specific selectors
 */

const makeSelectIsVerify = () =>
  createSelector(
    selectVerifySlackDomain,
    subState => subState.isVerify
  );

const makeSelectError = () =>
  createSelector(
    selectVerifySlackDomain,
    subState => subState.error
  );

export { makeSelectIsVerify, makeSelectError };
